module.exports = __webpack_public_path__ + "img/upload-icon.5dbf8c5a.svg";